jQuery(function($) {

	const header = document.querySelector('#header');

	function getCookie(cName) {
	      const name = cName + "=";
	      const cDecoded = decodeURIComponent(document.cookie); //to be careful
	      const cArr = cDecoded .split('; ');
	      let res;
	      cArr.forEach(val => {
	          if (val.indexOf(name) === 0) res = val.substring(name.length);
	      })
	      return res;
	}

	$(document).ready(function() {

		var root = document.documentElement;
		root.style.setProperty('--header-height', header.offsetHeight + "px");

		var bodyBlackout = $('.body-blackout');

		$('.popup-trigger').on('click', function(e) {
			var popup = $(this).data('popup-trigger');
			triggerPopup(popup);
		});

		function triggerPopup( popup ) {
			var popupModal = $('[data-popup-modal="'+popup+'"]');

			if ( !popupModal.length ) {
				return false;
			}

			popupModal.addClass('is--visible');
			bodyBlackout.addClass('is-blacked-out');

			$('.popup-modal__close', popupModal).on('click', function(e) {
				popupModal.removeClass('is--visible');
				bodyBlackout.removeClass('is-blacked-out');
			});

			bodyBlackout.on('click', function(e) {
				popupModal.removeClass('is--visible');
				bodyBlackout.removeClass('is-blacked-out');
			});
		}

		$('.gated-link').click( function(e) {
			e.preventDefault();
			var gatedAccess = getCookie('sosf_gated_access');
			var gatedLink = $(this).data('gated-link');
			if ( !gatedAccess ) {
				console.log(gatedLink);
				document.forms["gform_15"].elements["input_15_16"].value = gatedLink;
				triggerPopup('gated-content');
			} else {
				if ( gatedLink ) {
					window.open(gatedLink, '_blank');
				}
			}
		});

	    $('.academy-gated-link').click( function(e) {
			e.preventDefault();
			var gatedAccess = getCookie('sosf_academy_gated_access');
			if ( !gatedAccess ) {
				triggerPopup('academy-gated-content');
			} else {
				var gatedLink = $(this).data('gated-link');
				if ( gatedLink ) {
					window.open(gatedLink, '_blank');
				}
			}
		});

		function checkGatedFormCookie() {
			var cookie = getCookie('sosf_gated_access');
			if ( cookie ) {
				$('body').addClass('gated-form-filled');
			}
		}
		checkGatedFormCookie();

		$(document).on('gform_confirmation_loaded', function(event, formId){
			if ( formId == 15 ) {
				document.cookie = "sosf_gated_access=1; path=/; SameSite=Strict; max-age=7776000";
				checkGatedFormCookie();
			}
			if ( formId == 18 ) {
				document.cookie = "sosf_academy_gated_access=1; path=/; SameSite=Strict; max-age=7776000";
			}
	    });

	});
});